import module from 'fanconsultores/module.js'

const schema = {
  permisos: {
    catalogos: 'boolean',
    cargaNomina: 'boolean',
    cargaServicios: 'boolean',
    cotizacion: 'boolean',
    donaciones: 'boolean',
    empresasConceptos: 'boolean',
    finiquitos: 'boolean',
    fondoReserva: 'boolean',
    pendientes: 'boolean',
    sumario: 'boolean',
  },
}

class AdminDashboardNominasService {
  constructor ($http) {
    this.$http = $http
  }

  get () {
    return this.$http.get('/api/dashboard/nominas', {
      schema,
    })
  }
}

module.service('AdminDashboardNominas', AdminDashboardNominasService)



// WEBPACK FOOTER //
// ./src/fanconsultores/services/Admin/Dashboard/Nominas.js